var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 116,
    viewBox: "0 0 140 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.423 109.351H120.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.866 43.976s26.145-.967 32.259 24.25C123.238 93.444 98 107.024 86 107.024s-31.003-8.029-31.003-33.419c0-25.39 29.87-29.63 29.87-29.63z",
    fill: "#ED1C24",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#DF0D15",
    strokeWidth: 3,
    cx: 86,
    cy: 75,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.398 35.609V23.593c1.067-3.955-1.066-5.933-6.398-5.933H35.15c-3.913-.232-5.87 1.746-5.87 5.933v79.561c-.318 4.131.859 6.197 3.53 6.197",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.644 17.642V7.367H68.5v10.275M75.178 38.227v-4.671H37.976v12.426h19.972M51.267 56H37.976v13.918h8.685",
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M83.665 60.802h9.564l-4.091 11.211h5.032l-17.938 21.43 7.433-15.61-8.487.202z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DF0D15",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.221 80.476h-8.245v12.968h11.97M83.5 78.035h-8.322l8.321-17.233h9.73l-4.663 11.456h5.989L77 93.444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon-battery.da9c7e749d894613dc03e495b24bc089.svg";
export { ForwardRef as ReactComponent };